/**
 * Déroulant de langue — pages publiques uniquement (connexion, invitation, partage).
 *
 * Une fois connecté, la langue vit dans le menu du compte et nulle part ailleurs
 * (coquille.md §6.3) : ce composant ne doit jamais apparaître dans la barre applicative.
 */

import { useTranslation } from 'react-i18next';

import { DD_LABEL, DD_TRIGGER } from '../../ui/theme.js';

import { ChoixLangue, LANGUES, langueActive } from './ChoixLangue.jsx';
import { Chevron, Deroulant } from './Deroulant.jsx';

export default function MenuLangue({ className = '' }) {
  const { t, i18n } = useTranslation();
  const active = LANGUES.find((l) => l.code === langueActive(i18n)) ?? LANGUES[0];

  return (
    <Deroulant
      className={className}
      label={t('a11y.changeLanguage')}
      declencheur={({ ouvert }) => (
        <span className={DD_TRIGGER}>
          <IconeLangue />
          <span className={`${DD_LABEL} !inline`} lang={active.code}>
            {active.nom}
          </span>
          <Chevron ouvert={ouvert} />
        </span>
      )}
    >
      <ChoixLangue />
    </Deroulant>
  );
}

/** Globe schématique — deux méridiens, un équateur. Traits 2 px, jamais de rond plein. */
function IconeLangue() {
  return (
    <svg viewBox="0 0 16 16" className="h-3.5 w-3.5 shrink-0" fill="none" aria-hidden="true">
      <rect x="2" y="2" width="12" height="12" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M2 8h12M8 2v12M5 2c-1.5 4-1.5 8 0 12M11 2c1.5 4 1.5 8 0 12"
        stroke="currentColor"
        strokeWidth="1.2"
      />
    </svg>
  );
}
